export default __webpack_public_path__ + "static/media/Fatine.dfc76ddb.png";